import axios from 'axios';

// Configure axios to include cookies with all requests
axios.defaults.withCredentials = true;

// Request interceptor to add Authorization header with stored token
axios.interceptors.request.use(
    (config) => {
        // Try to get token from localStorage (fallback for cross-origin issues)
        const token = localStorage.getItem('oscar_access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const csrfToken = localStorage.getItem('csrfToken');
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling and token management
axios.interceptors.response.use(response => {
    // Handle a successful response
    // If login response contains accessToken, store it in localStorage
    if (response.data && response.data.accessToken) {
        localStorage.setItem('oscar_access_token', response.data.accessToken);
    }
    if (response.data && response.data.csrfToken) {
        localStorage.setItem('csrfToken', response.data.csrfToken);
    }
    return response;
}, error => {
    // Handle errors
    if (error.response && error.response.status === 401) {
        // Clear stored token on authentication failure
        localStorage.removeItem('oscar_access_token');
    }
    if (error.response?.data?.error === 'auth_mismatch') {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('oscar_access_token');
        localStorage.removeItem('csrfToken');
        window.location.href = '/login';
    }
    return Promise.reject(error);
});
